import services from './index';
import { SEARCH_CAMPAIGN_URL, CAMPAIGN_URL } from 'consts/api';

class CampaignServices {
  searchCampaign(body = {}, options = {}) {
    return services.post(SEARCH_CAMPAIGN_URL, body, options);
  }

  resumeAllCampaign() {
    return services.post(`${CAMPAIGN_URL}/resumeFromMaintenance`);
  }

  pauseAllCampaign() {
    return services.post(`${CAMPAIGN_URL}/pauseForMaintenance`);
  }
}

export default new CampaignServices();
